import { staffStore } from '@/store/staff'
import { shopStore } from '@/store/shop'
import { notification } from 'antd'
import React from 'react'
import { createHashHistory, History } from 'history'
import ImportFinish from '@/assets/images/import-finish.svg'
import { goodsLibraryStore } from '@/views/main/modules/goods-manage/goods-storage/goods-library/store/goods-library'
import $msg from '@/utils/message'
import { mallOrderStore } from '@/views/main/modules/order-manage/order-mall/store'
import { showLayer } from '@/utils/layer'
import MallOrderDetail from '@/views/main/modules/order-manage/order-mall/order-list/order-detail/order-detail'

enum SocketEvents {
    taken_offline = 'taken_offline', // 强制下线
    seat_insufficient = 'seat_insufficient', // 台位不足
    shop_info_updated = 'shop_info_updated', // 店铺信息更新
    shop_config_updated = 'shop_config_updated', // 店铺设置更新
    shop_payment_updated = 'shop_payment_updated', // 店铺支付方式更新
    recharge_bonus_updated = 'recharge_bonus_updated', // 充值送活动更新
    member_discount_updated = 'member_discount_updated', // 会员折扣活动更新
    staff_permission_updated = 'staff_permission_updated', // 员工权限变更
    goods_info_updated = 'goods_info_updated', // 商品信息变更
    cashier_permission_updated = 'cashier_permission_updated', // 收银员权限变更
    online_order_count_update = 'online_order_count_update', // 在线订单数量变更
    mall_visitor_count_update = 'mall_visitor_count_update', // 商城访客新增访客数量更新
    ls_goods_import_finished = 'ls_goods_import_finished', // 老零售商品导入完成
    shop_new_order_announce = 'shop_new_order_announce', // 商城新订单提示
    chain_shop_notification_add = 'chain_shop_notification_add', // 连锁分店消息通知新增
    chain_shop_notification_updated = 'chain_shop_notification_updated', // 连锁分店消息通知更新
}

export { SocketEvents }

interface SocketEvent {
    event: SocketEvents
    message: string
    data: any
}

type SocketEventListener = (event: SocketEvent) => void

type removeEventListen = () => void

export class SocketManager {
    private socket!: WebSocket
    private socketListeners = new Set<SocketEventListener>()
    private isConnect = false
    private isTimeout = false
    private keepAliveTimeInterval!: NodeJS.Timeout
    private checkTimeoutTimer!: NodeJS.Timeout

    // constructor() {
    // }

    public async start() {
        if (this.socket && this.socket.readyState !== WebSocket.CLOSED) {
            this.socket.close()
        }
        this.isConnect = false
        this.isTimeout = false
        let cashierWssAddress = ''
        if (process.env.NODE_ENV === 'development') {
            cashierWssAddress = 'https://cashiertest.senguo.me/api'.replace('https', 'wss')
        } else {
            cashierWssAddress = process.env.REACT_APP_SERVER_IP!.replace('https', 'wss')
        }

        // await SimpleChannels.getDeviceSN()
        const wsip =
            cashierWssAddress +
            `/ws/keeponline?staff_id=${staffStore.staffInfo?.id}&cashier_sn=123141&shop_id=${shopStore.shopInfo?.id}`
        this.socket = new WebSocket(wsip)

        this.socket.onopen = this.onOpen.bind(this)
        this.socket.onmessage = this.onMessage.bind(this)
        this.socket.onerror = this.onError.bind(this)
        this.socket.onclose = this.onClose.bind(this)
    }

    public stop() {
        clearInterval(this.checkTimeoutTimer)
        clearInterval(this.keepAliveTimeInterval)
        if (this.socket) {
            this.socket.close()
        }
        this.isConnect = false
        this.isTimeout = false
    }

    public addEventListener(fn: SocketEventListener): removeEventListen {
        this.socketListeners.add(fn)

        return () => {
            this.socketListeners.delete(fn)
        }
    }

    public removeEventListener(fn: SocketEventListener) {
        this.socketListeners.delete(fn)
    }

    private onOpen(event: Event) {
        console.info('socket 建立连接')
        this.isConnect = true
        this.keepAlive()
    }

    private onMessage(event: MessageEvent) {
        const data = JSON.parse(event.data)
        if (Object.keys(data.data).length) {
            console.info('socket 收到消息', data)
        }
        this.dispathEvent(data)

        if (this.checkTimeoutTimer) {
            clearTimeout(this.checkTimeoutTimer)
        }
        this.isTimeout = false
        this.checkTimeoutTimer = setTimeout(() => {
            if (this.isConnect) {
                this.isTimeout = true
                console.info('socket 连接超时')
            }
        }, 40 * 1000)
    }

    private onError(event: Event) {
        if (event.currentTarget === this.socket) this.isConnect = false
    }

    private onClose(ev: CloseEvent) {
        if (ev.currentTarget === this.socket) this.isConnect = false
    }

    private keepAlive() {
        clearInterval(this.keepAliveTimeInterval) // 防止重复调用
        this.keepAliveTimeInterval = setInterval(() => {
            if (this.socket && this.socket.readyState === WebSocket.CONNECTING) {
                return
            }
            if (this.socket && this.socket.readyState === WebSocket.OPEN && this.isConnect && !this.isTimeout) {
                this.socket.send('❤️')
            } else {
                this.start()
            }
        }, 10 * 1000)
    }

    private dispathEvent(event: SocketEvent) {
        this.socketListeners.forEach(fn => fn(event))
    }
}

export const socketManager = new SocketManager()

socketManager.addEventListener(socketEvent => {
    switch (socketEvent.event) {
        case SocketEvents.ls_goods_import_finished: // 老零售商品导入完成
            handleGoodsImportFinish()
            break
        case SocketEvents.shop_new_order_announce: // 商城新单语音提醒
            handleShopNewOrder(socketEvent.data)
            break
        case SocketEvents.shop_config_updated: // 商城新单语音提醒
            handleShopConfigUpdate()
            break
    }
})

function handleShopConfigUpdate() {
    shopStore.getShopConfig()
}

function handleShopNewOrder(data: any) {
    console.info('data:', data)
    if (shopStore.shopInfo?.shop_config && shopStore.shopInfo?.shop_config.app_order_announce) {
        mallOrderStore.setOrderListRefresh()
        openNotifice({
            key: `new-mall-order-${data.order_no || 0}`,
            onClick: history => {
                if (/orderMall/.test(history.location.pathname) && history.location.pathname) {
                    notification.close(`new-mall-order-${data.order_no || 0}`)
                } else {
                    history.push('/main/order/orderMall')
                    notification.close(`new-mall-order-${data.order_no || 0}`)
                }
                if (data.order_no) showLayer(<MallOrderDetail orderNo={data.order_no} />)
            },
            title: '您有新的订单，请及时处理',
            des: '点击查看',
        })
        const index = shopStore.shopInfo?.shop_config.voice_customization || 0
        setTimeout(() => {
            try {
                const audio = new Audio()
                if (index === 2) {
                    audio.volume = 1
                } else {
                    audio.volume = 0.8
                }
                audio.currentTime = 0
                const audioMap = [1, 2, 3].map(i => `https://v.senguo.cc/order_alert_${i}.mp3`)
                audio.src = audioMap[index]
                audio.play()
            } catch (e) {
                $msg('error', '语音播放失败')
            }
        }, 10)
    }
}

const openNotifice = (options: {
    key: string
    onClick: (history: History<any>) => void
    title: string
    des: string
}) => {
    setTimeout(() => {
        notification.open({
            icon: <img src={ImportFinish} data-margin-top-10 alt="" />,
            style: {
                borderRadius: '10px',
                cursor: 'pointer',
            },
            key: options.key,
            onClick: () => {
                const history = createHashHistory()
                options.onClick(history)
            },
            message: (
                <div data-color-000 data-font-size-20 data-font-weight-600>
                    {options.title}
                </div>
            ),
            description: (
                <div data-color-000 data-font-size-14>
                    {options.des}
                </div>
            ),
            duration: null,
        })
    }, 100)
}

function handleGoodsImportFinish() {
    openNotifice({
        key: 'import-ing',
        onClick: history => {
            if (/goodsLibrary/.test(history.location.pathname) && history.location.pathname) {
                goodsLibraryStore.resetGoodTableData()
                notification.close('import-ing')
            } else {
                history.push('/main/goods/goodStorage/goodsLibrary')
                goodsLibraryStore.resetGoodTableData()
                notification.close('import-ing')
            }
        },
        title: '批量导入商品成功',
        des: '点击查看导入商品',
    })
}
